import 'core-js/stable';
import { createRoot } from 'react-dom/client';

import React from 'react';
import '../scss/main.scss';

const isMobile = {
  Android: () => navigator.userAgent.match(/Android/i),
  BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
  iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
  Opera: () => navigator.userAgent.match(/Opera Mini/i),
  Windows: () => navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i),
  any: () =>
    isMobile.Android() ||
    isMobile.BlackBerry() ||
    isMobile.iOS() ||
    isMobile.Opera() ||
    isMobile.Windows(),
};

globalThis.isMobile = isMobile.any();

// Config is injected inline into index.html as <script>window.config = {...};</script>
// - Local dev: esbuild injects merged development.json + local.json at build time
// - Production (Docker/K8s): init.sh replaces __APP_CONFIG__ with APP_CONFIG env var
// - On-premise: same — operator sets APP_CONFIG env var with their config JSON

// For the sake of satisfying the author of global-cache module:
// https://github.com/ljharb/global-cache/issues/47#issuecomment-991976187
globalThis.global = globalThis;

import('./components/App').then(({ default: App }) => {
  const root = createRoot(document.getElementById('app'));
  root.render(<App />);
});
